/* RESPONSIBLE TEAM: team-ai-insights */
import { type LogicalFilter } from 'embercom/components/reporting/custom/filters';
import { type FlexibleQueryTimeRange } from 'embercom/services/reporting-csv-export';
import ajax from 'embercom/lib/ajax';

export interface InsightsSummaryResult {
  summaryText: string;
}

interface LoadInsightsSummaryArgs {
  appId: string;
  adminId: number;
  filter: LogicalFilter;
  timeRange: FlexibleQueryTimeRange;
  sortByAttributeId: string;
  sortDirection: 'asc' | 'desc';
  syntheticDataUseCase: string | null;
  timezone: string;
  summaryType: 'issue_summaries' | 'cxscore_drivers' | 'attribute_drivers';
  selectedCxAttribute?: string;
  maxConversationCount?: number;
}

export async function loadInsightsSummary({
  appId,
  adminId,
  filter,
  timeRange,
  sortByAttributeId,
  sortDirection,
  syntheticDataUseCase,
  timezone,
  summaryType,
  selectedCxAttribute,
  maxConversationCount,
}: LoadInsightsSummaryArgs): Promise<InsightsSummaryResult> {
  let params: Record<string, unknown> = {
    app_id: appId,
    admin_id: adminId,
    filter,
    time: timeRange,
    sort_by_attribute_id: sortByAttributeId,
    sort_direction: sortDirection,
    synthetic_data_use_case: syntheticDataUseCase,
    time_zone: timezone,
    summary_type: summaryType,
    max_conversation_count: maxConversationCount || 100,
  };

  if (selectedCxAttribute) {
    params.selected_cx_attribute = selectedCxAttribute;
  }

  let response = await ajax({
    url: '/ember/ai_insights/conversations_summary',
    type: 'POST',
    data: JSON.stringify(params),
  });

  return {
    summaryText: response.summary_text,
  };
}
